<template>
  <v-layout row justify-center>
    <v-dialog v-model="suggestedKeywordsDialog" persistent max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline mr-4">
            <v-icon class="pr-2">more</v-icon>
            Suggested Keywords
          </span>
          <v-btn absolute right depressed flat fab small @click="closeModal()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            v-model="selected"
            :items="suggestedKeywords"
            hide-actions
            class="no-action-table suggested-modal-table"
            value="suggestion"
            item-key="suggestion"
            :loading="loading"
            select-all
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th class="text-xs-center">
                  <v-checkbox
                    :input-value="props.all"
                    primary
                    hide-details
                    @click.native="toggleAll()"
                  ></v-checkbox>
                </th>
                <template v-for="header in props.headers">
                  <th
                    :key="header.text"
                    :aria-sort="header.sortable ? '' : null"
                    :aria-label="header.text + ': Not sorted.'"
                    @click="return false"
                    :class="['column ', header.sortable ? 'sortable' : '', header.align === 'middle' ? 'text-xs-center' : 'text-xs-left', header.visibility, !header.sort_padding || 'pr-3']"
                  >
                    <span>
                      <!-- <v-icon v-if="header.sortable && (!header.align || header.align === 'right')">arrow_upward</v-icon> -->
                      <span v-html="header.text"></span>
                      <v-icon v-if="header.sortable && (header.align === 'left' || header.align === 'middle')">arrow_upward</v-icon>
                    </span>
                  </th>
                </template>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  v-model="props.selected"
                  primary
                  hide-details
                  @change="toggleSelected(props.item)"
                ></v-checkbox>
              </td>
              <td>
                {{ props.item.suggestion ? remmoveQuotesFromStr(props.item.suggestion) : '-' }}
              </td>
              <td class="text-xs-center">
                {{ props.item.volume }}
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap justify-center class="text-xs-center">
            <v-spacer class="xs-d-none"></v-spacer>
            <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
            <v-btn color="primary" flat
              @click="$router.push({name: 'SeoKeywords', query: { keywords: selectedKeywords, engine_id: engineId }})"
              :loading="loading"
              :disabled="loading || !selected.length"
            >Add to My SEO Keywords</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'SuggestedKeywordsBoxModal',
  props: ['suggestedKeywordsDialog', 'suggestedKeywords', 'engineId'],
  data () {
    return {
      // testData: [{'keyword': 'test 1', 'volume': 1}, {'keyword': 'test 1', 'volume': 1}, {'keyword': 'test 1', 'volume': 1}, {'keyword': 'test 1', 'volume': 1}, {'keyword': 'test 1', 'volume': 1}, {'keyword': 'test 1', 'volume': 1}, {'keyword': 'test 1', 'volume': 1}, {'keyword': 'test 1', 'volume': 1}, {'keyword': 'test 1', 'volume': 1}, {'keyword': 'test 1', 'volume': 1}],
      selected: [],
      loading: false,
      selectedKeywords: [],
      headers: [
        { text: 'Keyword', value: 'suggestion', sortable: false },
        { text: 'Volume', value: 'volume', sortable: false, align: 'middle' }
      ]
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
    // this.suggestedKeywords = this.testData
    // if (this.keyword && (this.engineId || this.engineId === 0)) {
    //   this.getTopCompetitors()
    // }
  },
  watch: {
    'suggestedKeywordsDialog': function () {
      if (this.suggestedKeywordsDialog && this.project) {
        // this.getTopCompetitors()
      }
    }
  },
  computed: {
    projectCompetitorsDomains: function () {
      return this.projectCompetitors ? this.projectCompetitors.map((competitor) => { return competitor.domain }) : []
    }
  },
  methods: {
    toggleSelected (keyword) {
      if (this.selected.includes(keyword)) {
        this.selectedKeywords.push(keyword.suggestion)
      } else {
        let index = this.selectedKeywords.indexOf(keyword.suggestion)
        if (index > -1) this.selectedKeywords.splice(index, 1)
      }
    },
    toggleAll () {
      this.selectedKeywords = []
      let notMonitoredKeywords = this.suggestedKeywords.filter(item => !item.monitored)
      if (this.selected.length) {
        if (this.selected.length === notMonitoredKeywords.length) {
          this.selected = []
        } else {
          this.selected = notMonitoredKeywords
        }
      } else {
        this.selected = notMonitoredKeywords
      }
      this.selectedKeywords = this.selected.map(item => item.suggestion)
    },
    remmoveQuotesFromStr (keyword) {
      return keyword.replace(/^"(.+(?="$))"$/, '$1')
    },
    closeModal () {
      this.$parent.$emit('suggestedKeywordsDialog', false)
    }
  }
}
</script>

<style scoped>
.suggested-modal-table thead tr th, .suggested-modal-table tbody tr td {
  padding: 0 10px;
}
</style>
<style lang="scss">
.suggested-modal-table.default-custom-table .v-table th:first-child {
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/boxes/SuggestedKeywordsBoxModal.vue